import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "../Layout/Navigation";
import PageMetaData from "../components/PageMetaData";
import { motion } from "framer-motion";
const Home = () => {
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowCursor(false);
    }, 4.7 * 1000);
  }, []);

  return (
    <>
      <PageMetaData
        title="Yuko Murayama"
        description="Portfolio of Yuko Murayama"
      />
      <Navigation init={true} />

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0, display: "none" }}
        transition={{ duration: 0.5 }}
      >
        <main
          style={{ display: "block", position: "relative", height: "100vh" }}
        >
          <div className="home">
            <h1
              className={
                showCursor ? "home__typewriter" : "home__typewriter__stop"
              }
            >
              Hi, I'm Yuko a Software Developer
            </h1>
            <p>
              I am familiar with JavaScript, TypeScript, Java, Python, React,
              Next.js,PHP, and Node
            </p>
            <div>
              <button>
                <Link to="/work">View work</Link>
              </button>
              <button>
                <Link to="/about">About me</Link>
              </button>
            </div>
          </div>
        </main>
      </motion.div>
    </>
  );
};
export default Home;
